const Reflux = require("reflux");
const DealRankingActions = require("../actions/deal-ranking-actions");

const DealRankingStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      ranking: []
    }
  },

  init: function() {
    this.listenTo(DealRankingActions.fetchData, this.onFetchStarted);
    this.listenTo(DealRankingActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(DealRankingActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        ranking: data.deal_ranking
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = DealRankingStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/deal-ranking-store.js